exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n    font-size: 16px;\n    text-align: start;\n}\n\n.newsItem {\n    position: relative;\n    display: inline-block;\n    max-width: 40%;\n    max-height: 30%;\n    margin: 1% 3% 1% 3%;\n}\n\n.newsItem img {\n    max-width: 100%;\n    max-height: 50vh;\n    overflow: hidden;\n}", ""]);

// exports
